import {all, fork ,call, put, takeEvery, takeLatest  } from 'redux-saga/effects'
import { push } from 'react-router-redux';
import NetworkHandler from '../net/NetworkHandler'
import StorageHandler from '../storage/StorageHandler';
import * as ACTIONS from '../containers/constants';
import { error ,success } from '../components/Alert/actions';
import {updateUserInformation} from '../containers/Home/actions';
const storageHandler = new StorageHandler();


function* locationUserSaga(action){
    const Network = new NetworkHandler();
    try {
		 if(localStorage.getItem('joinedPlace'))
		   {			   
				action.payload.location_id = JSON.parse(localStorage.getItem('joinedPlace')).info.Infodex_ID;
		   }
		  
        const response = Network.requestSendLocation(action.payload);
    } catch (errorMsg) {
        yield put(
            error({
             message: `Unable to send location, please try again.${errorMsg}`,
            })
        );
    }
}


export default function* locationsSagas() {
  yield takeLatest(ACTIONS.CRYODEX_GET_LOCATION, locationUserSaga);
}

